// @ts-nocheck

import axios from "axios";
import { useEffect, useState } from "react";
import Select, { StylesConfig, MultiValue } from "react-select";
import colors from "tailwindcss/colors";

type Option = {
  value: string;
  label: string;
};

function formatToSelect(options: string[]) {
  return options.map((option) => {
    const value = option.split(" - ")[0];
    return {
      value,
      label: option,
    };
  });
}

const customStyles: StylesConfig<Option, true> = {
  control: (provided) => ({
    ...provided,
    outline: "none",
    boxShadow: "none",
    backgroundColor: colors.zinc[950],
    color: colors.white,
    borderColor: colors.gray[600],
    height: `${parseInt(provided.height as string) + 2}px`,
    minHeight: `${parseInt(provided.minHeight as string) + 2}px`,
    "&:hover": {
      borderColor: colors.zinc[800],
      backgroundColor: colors.zinc[800],
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: colors.zinc[950],
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? colors.gray[700] : colors.zinc[950],
    color: colors.white,
    "&:active": {
      backgroundColor: colors.zinc[600],
    },
    "&:hover": {
      backgroundColor: colors.zinc[700],
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: colors.gray[700],
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: colors.white,
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: colors.white,
    "&:hover": {
      backgroundColor: colors.gray[400],
      color: colors.white,
    },
  }),
  // Adicionando estilo para o valor selecionado
  singleValue: (provided) => ({
    ...provided,
    color: colors.white,
  }),
  // Adicionando estilo para o placeholder
  placeholder: (provided) => ({
    ...provided,
    color: colors.gray[400],
  }),
  // Adicionando estilo para o indicador de carregamento
  loadingMessage: (provided) => ({
    ...provided,
    color: colors.white,
  }),
};

export function SelectCenterCost({ setCenterCost }) {
  const [selectedOptions, setSelectedOptions] = useState<MultiValue<Option>>([]);
  const [options, setOptions] = useState<Option[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setCenterCost(selectedOptions);
  }, [selectedOptions]);

  useEffect(() => {
    (async function fetchData() {
      try {
        setIsLoading(true);

        //await new Promise((resolve) => setTimeout(resolve, 10000));

        const { data } = await axios.get(
          "https://radar.tlpservicos.com.br/api/toa/tim-cc"
        );

        setOptions(
          data.map((item: { centro_custo: string; descricao: string }) => ({
            value: item.centro_custo,
            label: `${item.centro_custo}${item.descricao && "\n"}${item.descricao}`,
          }))
        );
      } catch (error) {
        console.error(error);
      } finally {
        setIsLoading(false);
      }
    })();
  }, []);

  const handleChange = (selected: MultiValue<Option>) => {
    setSelectedOptions(selected);
  };

  return (
    <div className="w-[500px]">
      <Select<Option, true>
        // isMulti
        options={options}
        styles={customStyles}
        value={selectedOptions}
        onChange={handleChange}
        placeholder={isLoading ? "Carregando..." : "Selecione..."}
        className="mb-2"
        closeMenuOnSelect={false}
        isLoading={isLoading}
        loadingMessage={() => "Carregando..."}
        noOptionsMessage={() => "Nenhuma opção encontrada"}
      />
    </div>
  );
}
